import { useTranslation } from "react-i18next";
import styles from "./RulesFragment.module.css";
import Card from "../../common/Card";

const RulesFragment = () => {
	const { t } = useTranslation();

	// Helper function to render HTML content safely
	const renderTerm = (termKey) => {
		return { __html: t(termKey) };
	};

	return (
		<div className={styles.container}>
			{/* Rules Card */}
			<Card title={t("rules.card.rules.title")}>
				<p
					style={{
						padding: "10px",
						backgroundColor: "#f2f2f2",
						borderRadius: "10px",
						marginBottom: "20px",
					}}
					dangerouslySetInnerHTML={{ __html: t("rules.temporary_notice") }}
				/>

				<p dangerouslySetInnerHTML={renderTerm("rules.intro")} />
				<ol className={styles.rulesList}>
					<li dangerouslySetInnerHTML={renderTerm("rules.rule1")} />
					<li dangerouslySetInnerHTML={renderTerm("rules.rule2")} />
					<li dangerouslySetInnerHTML={renderTerm("rules.rule3")} />
					<li dangerouslySetInnerHTML={renderTerm("rules.rule4")} />
					<li dangerouslySetInnerHTML={renderTerm("rules.rule5")} />
				</ol>
			</Card>

			{/* Goals Card */}
			<Card title={t("rules.card.goals.title")}>
				<div className={styles.pointsTable}>
					<div className={styles.pointsRow}>
						<div>{t("rules.goals.forwardGoals")}</div>
						<div className={styles.pointValue}>{t("rules.goals.forwardGoalsValue")}</div>
					</div>
					<div className={styles.pointsRow}>
						<div>{t("rules.goals.midfielderGoals")}</div>
						<div className={styles.pointValue}>{t("rules.goals.midfielderGoalsValue")}</div>
					</div>
					<div className={styles.pointsRow}>
						<div>{t("rules.goals.defenderGoals")}</div>
						<div className={styles.pointValue}>{t("rules.goals.defenderGoalsValue")}</div>
					</div>
					<div className={styles.pointsRow}>
						<div>{t("rules.goals.goalkeeperGoals")}</div>
						<div className={styles.pointValue}>{t("rules.goals.goalkeeperGoalsValue")}</div>
					</div>
					<div className={styles.pointsRow}>
						<div>{t("rules.goals.penaltyGoals")}</div>
						<div className={styles.pointValue}>{t("rules.goals.penaltyGoalsValue")}</div>
					</div>
					<div className={styles.pointsRow}>
						<div>{t("rules.goals.ownGoals")}</div>
						<div className={styles.pointValue}>{t("rules.goals.ownGoalsValue")}</div>
					</div>
					<div className={styles.pointsRow}>
						<div>{t("rules.goals.concededGoals")}</div>
						<div className={styles.pointValue}>{t("rules.goals.concededGoalsValue")}</div>
					</div>
				</div>
			</Card>

			{/* Clean sheets Card */}
			<Card title={t("rules.card.cleanSheets.title")}>
				<div className={styles.pointsTable}>
					<div className={styles.pointsRow}>
						<div>{t("rules.cleanSheets.goalkeeperCleanSheet")}</div>
						<div className={styles.pointValue}>{t("rules.cleanSheets.goalkeeperCleanSheetValue")}</div>
					</div>
					<div className={styles.pointsRow}>
						<div>{t("rules.cleanSheets.defenderCleanSheet")}</div>
						<div className={styles.pointValue}>{t("rules.cleanSheets.defenderCleanSheetValue")}</div>
					</div>
					<div className={styles.pointsRow}>
						<div>{t("rules.cleanSheets.midfielderCleanSheet")}</div>
						<div className={styles.pointValue}>{t("rules.cleanSheets.midfielderCleanSheetValue")}</div>
					</div>
				</div>
			</Card>

			{/* Cards Card */}
			<Card title={t("rules.card.cards.title")}>
				<div className={styles.pointsTable}>
					<div className={styles.pointsRow}>
						<div>{t("rules.cards.yellowCard")}</div>
						<div className={styles.pointValue}>{t("rules.cards.yellowCardValue")}</div>
					</div>
					<div className={styles.pointsRow}>
						<div>{t("rules.cards.redCard")}</div>
						<div className={styles.pointValue}>{t("rules.cards.redCardValue")}</div>
					</div>
				</div>
			</Card>

			{/* Misc Card */}
			<Card title={t("rules.card.misc.title")}>
				<div className={styles.pointsTable}>
					<div className={styles.pointsRow}>
						<div>{t("rules.misc.assists")}</div>
						<div className={styles.pointValue}>{t("rules.misc.assistsValue")}</div>
					</div>
					<div className={styles.pointsRow}>
						<div>{t("rules.misc.shotsOnTarget")}</div>
						<div className={styles.pointValue}>{t("rules.misc.shotsOnTargetValue")}</div>
					</div>
					<div className={styles.pointsRow}>
						<div>{t("rules.misc.tackles")}</div>
						<div className={styles.pointValue}>{t("rules.misc.tacklesValue")}</div>
					</div>
					<div className={styles.pointsRow}>
						<div>{t("rules.misc.saves")}</div>
						<div className={styles.pointValue}>{t("rules.misc.savesValue")}</div>
					</div>
					<div className={styles.pointsRow}>
						<div>{t("rules.misc.minutesOver60")}</div>
						<div className={styles.pointValue}>{t("rules.misc.minutesOver60Value")}</div>
					</div>
					<div className={styles.pointsRow}>
						<div>{t("rules.misc.minutesUnder60")}</div>
						<div className={styles.pointValue}>{t("rules.misc.minutesUnder60Value")}</div>
					</div>
					<div className={styles.pointsRow}>
						<div>{t("rules.misc.penaltyWon")}</div>
						<div className={styles.pointValue}>{t("rules.misc.penaltyWonValue")}</div>
					</div>
					<div className={styles.pointsRow}>
						<div>{t("rules.misc.penaltiesConceded")}</div>
						<div className={styles.pointValue}>{t("rules.misc.penaltiesConcededValue")}</div>
					</div>
					<div className={styles.pointsRow}>
						<div>{t("rules.misc.penaltyMissed")}</div>
						<div className={styles.pointValue}>{t("rules.misc.penaltyMissedValue")}</div>
					</div>
					<div className={styles.pointsRow}>
						<div>{t("rules.misc.offsides")}</div>
						<div className={styles.pointValue}>{t("rules.misc.offsidesValue")}</div>
					</div>
					<div className={styles.pointsRow}>
						<div>{t("rules.misc.foulsCommitted")}</div>
						<div className={styles.pointValue}>{t("rules.misc.foulsCommittedValue")}</div>
					</div>
				</div>
			</Card>

			{/* Captains Card */}
			<Card title={t("rules.card.captains.title")}>
				<ol className={styles.rulesList} start="6">
					<li dangerouslySetInnerHTML={renderTerm("rules.rule6")} />
					<li dangerouslySetInnerHTML={renderTerm("rules.rule7")} />
				</ol>
			</Card>

			{/* Eligibility & Prizes Card */}
			<Card title={t("rules.card.eligibility.title")}>
				<ol className={styles.rulesList} start="8">
					<li dangerouslySetInnerHTML={renderTerm("rules.rule8")} />
					<li dangerouslySetInnerHTML={renderTerm("rules.rule9")} />
					<li dangerouslySetInnerHTML={renderTerm("rules.rule10")} />
					<li dangerouslySetInnerHTML={renderTerm("rules.rule11")} />
					<li dangerouslySetInnerHTML={renderTerm("rules.rule12")} />
					<li dangerouslySetInnerHTML={renderTerm("rules.rule13")} />
				</ol>
			</Card>

			{/* Weekly Prizes Table Card */}
			<Card title={t("rules.card.weeklyPrizes.title")}>
				<div className={styles.prizesTable}>
					<div className={`${styles.tableRow} ${styles.tableHeader}`}>
						<div>{t("rules.weeklyPrizes.position")}</div>
						<div>{t("rules.weeklyPrizes.eur")}</div>
						<div>{t("rules.weeklyPrizes.gbp")}</div>
						<div>{t("rules.weeklyPrizes.zar")}</div>
						<div>{t("rules.weeklyPrizes.ghs")}</div>
					</div>
					<div className={styles.tableRow}>
						<div>1</div>
						<div>{t("rules.weeklyPrizes.1st.eur")}</div>
						<div>{t("rules.weeklyPrizes.1st.gbp")}</div>
						<div>{t("rules.weeklyPrizes.1st.zar")}</div>
						<div>{t("rules.weeklyPrizes.1st.ghs")}</div>
					</div>
					<div className={styles.tableRow}>
						<div>2</div>
						<div>{t("rules.weeklyPrizes.2nd.eur")}</div>
						<div>{t("rules.weeklyPrizes.2nd.gbp")}</div>
						<div>{t("rules.weeklyPrizes.2nd.zar")}</div>
						<div>{t("rules.weeklyPrizes.2nd.ghs")}</div>
					</div>
					<div className={styles.tableRow}>
						<div>3</div>
						<div>{t("rules.weeklyPrizes.3rd.eur")}</div>
						<div>{t("rules.weeklyPrizes.3rd.gbp")}</div>
						<div>{t("rules.weeklyPrizes.3rd.zar")}</div>
						<div>{t("rules.weeklyPrizes.3rd.ghs")}</div>
					</div>
					<div className={styles.tableRow}>
						<div>4</div>
						<div>{t("rules.weeklyPrizes.4th.eur")}</div>
						<div>{t("rules.weeklyPrizes.4th.gbp")}</div>
						<div>{t("rules.weeklyPrizes.4th.zar")}</div>
						<div>{t("rules.weeklyPrizes.4th.ghs")}</div>
					</div>
					<div className={styles.tableRow}>
						<div>5</div>
						<div>{t("rules.weeklyPrizes.5th.eur")}</div>
						<div>{t("rules.weeklyPrizes.5th.gbp")}</div>
						<div>{t("rules.weeklyPrizes.5th.zar")}</div>
						<div>{t("rules.weeklyPrizes.5th.ghs")}</div>
					</div>
					<div className={styles.tableRow}>
						<div>6</div>
						<div>{t("rules.weeklyPrizes.6th.eur")}</div>
						<div>{t("rules.weeklyPrizes.6th.gbp")}</div>
						<div>{t("rules.weeklyPrizes.6th.zar")}</div>
						<div>{t("rules.weeklyPrizes.6th.ghs")}</div>
					</div>
					<div className={styles.tableRow}>
						<div>7</div>
						<div>{t("rules.weeklyPrizes.7th.eur")}</div>
						<div>{t("rules.weeklyPrizes.7th.gbp")}</div>
						<div>{t("rules.weeklyPrizes.7th.zar")}</div>
						<div>{t("rules.weeklyPrizes.7th.ghs")}</div>
					</div>
					<div className={styles.tableRow}>
						<div>8</div>
						<div>{t("rules.weeklyPrizes.8th.eur")}</div>
						<div>{t("rules.weeklyPrizes.8th.gbp")}</div>
						<div>{t("rules.weeklyPrizes.8th.zar")}</div>
						<div>{t("rules.weeklyPrizes.8th.ghs")}</div>
					</div>
					<div className={styles.tableRow}>
						<div>9</div>
						<div>{t("rules.weeklyPrizes.9th.eur")}</div>
						<div>{t("rules.weeklyPrizes.9th.gbp")}</div>
						<div>{t("rules.weeklyPrizes.9th.zar")}</div>
						<div>{t("rules.weeklyPrizes.9th.ghs")}</div>
					</div>
					<div className={styles.tableRow}>
						<div>10</div>
						<div>{t("rules.weeklyPrizes.10th.eur")}</div>
						<div>{t("rules.weeklyPrizes.10th.gbp")}</div>
						<div>{t("rules.weeklyPrizes.10th.zar")}</div>
						<div>{t("rules.weeklyPrizes.10th.ghs")}</div>
					</div>
				</div>
			</Card>

			{/* Final Rules Card */}
			<Card title={t("rules.card.finalRules.title")}>
				<ol className={styles.rulesList} start="14">
					<li dangerouslySetInnerHTML={renderTerm("rules.rule14")} />
					<li dangerouslySetInnerHTML={renderTerm("rules.rule15")} />
					<li dangerouslySetInnerHTML={renderTerm("rules.rule16")} />
				</ol>
			</Card>
		</div>
	);
};

export default RulesFragment;
